import { render, staticRenderFns } from "./OrderShow.vue?vue&type=template&id=6569cc8f&scoped=true&"
import script from "./OrderShow.vue?vue&type=script&lang=js&"
export * from "./OrderShow.vue?vue&type=script&lang=js&"
import style0 from "./OrderShow.vue?vue&type=style&index=0&id=6569cc8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6569cc8f",
  null
  
)

export default component.exports